import React from 'react';
import PropTypes from 'prop-types';
import { propTypes } from './wire-comment-components/prop-types';
import DesktopVariant from './wire-comment-components/desktop-variant';
import MobileVariant from './wire-comment-components/mobile-variant';
import { useIsMobile } from '../../shared/theme';

export default function WireComment(props) {
  const isMobile = useIsMobile();

  if (props.variant === 'mobile' && isMobile) {
    return <MobileVariant {...props} />;
  }

  if (props.variant === 'desktop' && !isMobile) {
    return <DesktopVariant {...props} />;
  }

  return null;
}

WireComment.propTypes = {
  wireSlug: PropTypes.string.isRequired,
  isCurrentUserConfirmed: PropTypes.bool.isRequired,
  showCommentLikeHint: PropTypes.bool.isRequired,
  comments: PropTypes.arrayOf(PropTypes.shape(propTypes)).isRequired,
  variant: PropTypes.oneOf(['mobile', 'desktop']).isRequired,
};
